import { makeStyles } from '@soil-capital/ui-kit/style';

export const useLogoStyles = makeStyles()(() => ({
    logo: { height: '40px' },
}));
